import React from "react"
import Typography from "@mui/material/Typography"
import urls from "../../config/urls"
import {Banner, BannerInfoIcon, BannerIconWrapper} from "./component"

export type MiniShoppingBagBannerProps = {
    message: string
    realm: string
}

const MiniShoppingBagBanner = ({message, realm}: MiniShoppingBagBannerProps) => {
    const testid = "header-mini-shopping-bag-item-banner"
    return (
        <Banner data-testid={testid}>
            <BannerIconWrapper>
                <BannerInfoIcon src={urls.informationIconUrl(realm)} alt="info icon" data-testid={`${testid}-icon`} />
            </BannerIconWrapper>
            <Typography variant="body3" data-testid={`${testid}-message`}>
                {message}
            </Typography>
        </Banner>
    )
}

export default MiniShoppingBagBanner
